import React from 'react'
import { Row } from 'react-bootstrap'
import classnames from 'classnames'

interface EnterpriseManagedBannerProps {
  message: string
  className?: string
}

export const EnterpriseManagedBanner = ({ message, className }: EnterpriseManagedBannerProps) => (
  <Row className={classnames('p-3 zocks-bg-color-primary-light gap-3 justify-content-center rounded', className)}>
    <div className='d-flex align-items-center gap-3'>
      <i className='bi bi-info-square zocks-text-primary consent-settings-info-square' />
      <span className='zocks-text-gray-900'>{message}</span>
    </div>
  </Row>
)
